import { Type, plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { ProjectMapLayer } from '@core/entities/project/ProjectMapLayer'
import { IProjectMap } from './IProjectMap'

export class ProjectMap extends Entity<IProjectMap> {
  disclaimer: string

  disclaimerActions?: { url: string; label: string }[]

  mapBoxStyleUrl: string

  @Type(() => Number)
  mapCenterLatitude: number

  @Type(() => Number)
  mapCenterLongitude: number

  @Type(() => Number)
  mapZoom: number

  canZoom: boolean

  maxBounds: {
    northeast: {
      latitude: number
      longitude: number
    }
    southwest: {
      latitude: number
      longitude: number
    }
  }

  @Type(() => ProjectMapLayer)
  layers: Array<ProjectMapLayer>

  public static new(payload: unknown): ProjectMap {
    const entity = plainToInstance(ProjectMap, payload)

    return entity
  }
}
